"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowRightComponentVerticalPosition = exports.ArrowLeftComponentVerticalPosition = void 0;

var react_1 = __importDefault(require("react"));

var arrow_right_svg_1 = __importDefault(require("./arrow-right.svg"));

function ArrowLeftComponentVerticalPosition(_ref) {
  var customClassName = _ref.customClassName,
      onClick = _ref.onClick;
  return react_1.default.createElement("div", {
    onClick: onClick,
    className: customClassName || "arrowSliderPosition md-1:left-unset left-0% md-1:right-60px xl:right-60px"
  }, react_1.default.createElement("img", {
    className: "transform rotate-180",
    src: arrow_right_svg_1.default,
    atl: ""
  }));
}

exports.ArrowLeftComponentVerticalPosition = ArrowLeftComponentVerticalPosition;
;

function ArrowRightComponentVerticalPosition(_ref2) {
  var customClassName = _ref2.customClassName,
      onClick = _ref2.onClick;
  return react_1.default.createElement("div", {
    onClick: onClick,
    className: customClassName || "arrowSliderPosition md-1:left-unset left-20% md-1:-right-0px xl:right-0px"
  }, react_1.default.createElement("img", {
    src: arrow_right_svg_1.default,
    atl: ""
  }));
}

exports.ArrowRightComponentVerticalPosition = ArrowRightComponentVerticalPosition;
;